export { default } from "./ClaimDealBox";
